import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {InfoPanel} from "@/scenes.ui/info-panel";

export class UnclosablePanel extends InfoPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, title: string, introTextValue: string, bodyTextValue: string, callback: () => unknown,
                okText: string = Tr('horosho')) {
        super(scene, canvas, title, introTextValue, bodyTextValue, callback, okText);
    }

    protected isClosable(): boolean {
        return false;
    }

    protected closeWithCallback() {
        this.onClose();
    }

}
